import type { Contact, Task } from "@/components/atomic-crm/types";

export const commercialStages = [
  { id: "to-review", name: "Da valutare" },
  { id: "to-contact", name: "Da contattare" },
  { id: "contacted", name: "Contattato" },
  { id: "conversation", name: "In conversazione" },
  { id: "proposal", name: "Proposta inviata" },
  { id: "client", name: "Cliente" },
  { id: "archived", name: "Archiviato" },
] as const;

export const getCommercialStage = (
  contact: Pick<Contact, "status" | "commercial_stage">,
) =>
  contact.commercial_stage ??
  (contact.status === "in-contract" ? "client" : "to-review");

export const commercialStageLabel = (
  contact: Pick<Contact, "status" | "commercial_stage">,
) =>
  commercialStages.find(({ id }) => id === getCommercialStage(contact))?.name ??
  "Da valutare";

export const updateKinds = [
  "Nota interna",
  "Bozza",
  "Messaggio inviato",
  "Risposta ricevuta",
  "Preventivo inviato",
] as const;
export const updateChannels = [
  "Email",
  "Instagram / DM",
  "WhatsApp",
  "Telefonata",
  "Incontro",
  "Altro",
] as const;

export const formatClientUpdate = (
  kind: string,
  channel: string,
  text: string,
) =>
  `${kind}${kind === "Nota interna" ? "" : ` · ${channel}`}\n\n${text.trim()}`;

export const taskDateLabel = (value: string | null | undefined) => {
  const date = value ? new Date(value) : null;
  return !date || Number.isNaN(date.getTime())
    ? "Data da verificare"
    : date.toLocaleDateString("it-IT");
};

// Calendar boundaries use the viewer's local timezone, including DST changes.
export const taskBucket = (
  task: Pick<Task, "blocked_reason" | "due_date">,
  now = new Date(),
) => {
  if (task.blocked_reason?.trim()) return "blocked";
  if (!task.due_date) return "undated";
  const due = new Date(task.due_date);
  if (Number.isNaN(due.getTime())) return "undated";
  const start = new Date(now);
  start.setHours(0, 0, 0, 0);
  const tomorrow = new Date(start);
  tomorrow.setDate(tomorrow.getDate() + 1);
  if (due < start) return "overdue";
  if (due < tomorrow) return "today";
  return "upcoming";
};
